import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const addProductsApi = async (inputData, authHeaders) => {
  // Implement the API call to fetch products data
  const apiInputData = { ...inputData, channel: "CRM", apiVerb: "ADD" };

  try {
    const res = await apiCallPost(apiPaths.addProducts, apiInputData, authHeaders);
    // // console.log('addProductsApi', res);
    if (res?.id) {
      return { data: { id: res.id }, status: true, msg: 'Product Added Successfully. Try clicking on search button to get proper result.' }
    }
    return { data: [], status: false, msg: res.msg ? res.msg : 'Error Occured Please Try Again.' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const getProductDataApi = async (inputData, authHeaders) => {
  const apiInputData = { ...inputData, channel: 'CRM', apiVerb: 'GET' };

  try {
    const res = await apiCallPost(apiPaths.addProducts, apiInputData, authHeaders);

    if (res && res.product) {
      const prod = res.product;
      const images = prod.productImages || prod.productImages || prod.images || [];
      const data = { ...prod, images };
      return { data, status: true, msg: res.message || 'Product data fetched successfully.' };
    }

    if (res && (res.id || res.productId || res.images)) {
      const prod = res;
      const images = prod.productImages || prod.images || [];
      const data = { ...prod, images };
      return { data, status: true, msg: res.message || 'Product data fetched successfully.' };
    }

    return { data: [], status: false, msg: res.msg ? res.msg : 'No images found.' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};
